"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Risk = void 0;
var Risk;
(function (Risk) {
    Risk[Risk["LOW"] = 0] = "LOW";
    Risk[Risk["MEDIUM"] = 1] = "MEDIUM";
    Risk[Risk["HIGH"] = 2] = "HIGH";
})(Risk = exports.Risk || (exports.Risk = {}));
//# sourceMappingURL=risk.enum.js.map